import React from 'react'
import { useMessage } from '../../hooks/message'
import { usePutRequest } from '../../hooks/request'
import { EXPENSE_REPORT_DETAIL } from '../../urls'
import ExpenseForm from './expense-create-form'

export default function ExpenseUpdate({ onCancel, item }) {
    const [showMessage] = useMessage()

    const client = usePutRequest({ url: EXPENSE_REPORT_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data, action) {
        const { success, error } = await client.request({ data })

        if (success) {
            onCancel()
            action.resetForm()
            showMessage('Успешно', 'is-success')
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered is-capitalized">
                <b>Изменить Отчет о затратах</b>
            </h1>

            <ExpenseForm loading={client.loading} initialValues={item} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
